import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { fadeUp, viewport } from "@/lib/motion";
import { IMAGES, SERVICE_KEYS } from "@/data";
import { useLang } from "@/context/LanguageContext";

export const Services = () => {
  const { t } = useLang();
  const s = t.services;
  return (
    <section id="services" className="py-24 md:py-32 bg-[#EDECE6] border-y border-[#E2E0D8] scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="overline text-[#C4A484] mb-5">{s.overline}</motion.p>
            <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewport} className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#0D2A27] max-w-xl">{s.heading}</motion.h2>
          </div>
          <motion.p variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={viewport} className="text-[#555] max-w-xs md:text-right">{s.sub}</motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[minmax(200px,auto)]">
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="md:row-span-2 relative overflow-hidden border border-[#E2E0D8] group min-h-[300px]">
            <img src={IMAGES.surgery} alt="Advanced surgical suite" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D2A27]/90 via-[#0D2A27]/20 to-transparent" />
            <div className="absolute bottom-0 p-7">
              <p className="overline text-[#C4A484] mb-2">{s.featureOverline}</p>
              <p className="font-serif text-3xl text-[#F7F6F2] leading-tight">{s.featureText}</p>
            </div>
          </motion.div>

          {SERVICE_KEYS.map((key, i) => {
            const item = t.treatments[key];
            return (
              <motion.div key={key} variants={fadeUp} custom={i % 3} initial="hidden" whileInView="show" viewport={viewport}>
                <Link to={`/treatment/${key}`} data-testid={`service-card-${key}`} className="group relative h-full bg-[#F7F6F2] border border-[#E2E0D8] p-7 flex flex-col justify-between transition-colors duration-500 hover:bg-[#0D2A27]">
                  <div className="flex items-center justify-between">
                    <span className="overline text-[#C4A484]">{item.tag}</span>
                    <span className="text-[#C4A484] transition-transform duration-300 group-hover:translate-x-1">→</span>
                  </div>
                  <div className="mt-10">
                    <h3 className="font-serif text-2xl text-[#0D2A27] transition-colors duration-500 group-hover:text-[#F7F6F2]">{item.name}</h3>
                    <p className="mt-3 text-sm text-[#555] leading-relaxed transition-colors duration-500 group-hover:text-[#F7F6F2]/70">{item.blurb}</p>
                    <span className="mt-4 inline-block text-xs font-semibold uppercase tracking-wider text-[#0D2A27] opacity-0 -translate-y-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0 group-hover:text-[#C4A484]">{s.viewCta} →</span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
